/**
 * QualiopiBadge — official Qualiopi logo PNG (downloaded from sellerie-academie.fr
 * and hosted locally via the backend static mount).
 *
 * Props:
 *   - size: 'sm' | 'md' | 'lg' (default md → h-9)
 *   - className: extra classes
 */
const heights = { sm: 28, md: 38, lg: 56 };

export const QualiopiBadge = ({ size = 'md', className = '' }) => {
  const h = heights[size] || heights.md;
  return (
    <img
      src="/logos/qualiopi-official.jpg"
      alt="Qualiopi processus certifié · République Française · Actions de formation"
      style={{ height: h, width: 'auto' }}
      className={className}
      loading="lazy"
    />
  );
};

export default QualiopiBadge;
